<template>
  <v-dialog
    v-model="dialog"
    width="328px">
    <div class="dialog-container">
      <h2>Reject Request</h2>
      <p>
        Are you sure to reject this request? This
        cannot be undone.
      </p>
      <div class="flex-sb">
        <div>
          <v-button @click="handlerCancel">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerYes">Yes</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'RejectRequest',
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerCancel() {
      this.dialog = false
    },
    handlerYes() {
      this.$emit('yes')
      this.dialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      p {
        padding-bottom: 10px;
        font-size: 16px;
      }
    }
</style>